{
    "GenericModal_PromptMessage": "Vuoi davvero chiudere questa finestra? Tutte le configurazioni modificate andranno perse alla chiusura.",
    "GenericModal_PromptConfirm": "SÌ",
    "GenericModal_PromptCancel": "Cancellare",
    "NAME": "GenericModal"
}